import { useEffect } from 'react';
import { useProductStore } from '@/store/productStore';
import { fetchProducts } from '@/services/erpnextApi';

export const useLoadProducts = () => {
  const setProducts = useProductStore((state) => state.setProducts);
  const setLoading = useProductStore((state) => state.setLoading);
  const setError = useProductStore((state) => state.setError);

  useEffect(() => {
    const loadProducts = async () => {
      setLoading(true);
      try {
        // Try to load from ERPNext
        const products = await fetchProducts();
        setProducts(products);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Unknown error');
        console.error('Error loading products:', err);
      } finally {
        setLoading(false);
      }
    };

    loadProducts();
  }, [setProducts, setLoading, setError]);
};
